import * as React from "react"
import Svg, { SvgProps, Path } from "react-native-svg"
/* SVGR has dropped some elements not supported by react-native-svg: title */
const SvgComponent = (props: SvgProps) => (
  <Svg
    width={800}
    height={800}
    viewBox="0 0 32 32"
    {...props}
    fill="none"
    stroke="none"
  >
    <Path
      fill={props.fill || '#000'}
      fillRule="evenodd"
      d="M27.887 12.04h-6.561L32.014 1.4l-1.4-1.39-10.676 10.63.031-6.48c0-.55-.443-.99-.99-.99-.546 0-.99.44-.99.99v8.87c0 .29.122.53.313.69a.99.99 0 0 0 .706.29h8.879a.985.985 0 1 0 0-1.97Zm-14.895 5.95H4.113a.985.985 0 1 0 0 1.97h6.561L-.014 30.6l1.4 1.39 10.677-10.63-.032 6.48c0 .55.443.99.99.99.546 0 .99-.44.99-.99v-8.87a.88.88 0 0 0-.314-.69.985.985 0 0 0-.705-.29Z"
    />
  </Svg>
)
export default SvgComponent
